import type { NavItem } from '../types';
import { FINANCE_PAGE } from '../pageAccess';

/**
 * Projects nav.
 *
 * `Calendar` is the SAME calendar as Field Service's (ADR-004: one calendar,
 * two doors) — it opens on the Install tab. There is no separate `Scheduler`
 * entry; that second surface stays retired.
 *
 * `All Projects` points at the board. The board is live — a registered page, a
 * selectable landing page and an E2E-swept route — but had no nav entry, so it
 * was reachable only through the view toggle on the Dashboard. It lists every
 * project regardless of stage, which makes it the right surface for someone
 * hunting a specific project by name or address (ISS-424).
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/projects' },
  { label: 'All Projects', path: '/projects/board' },
  // Crew schedule (company-wide) and money are closed to External accounts.
  { label: 'Calendar', path: '/projects/calendar', hideForExternal: true },
  { label: 'Equipment', path: '/projects/equipment' },
  // Linking invoices to projects is money work: Billing (P4) only (Nick 2026-10-02).
  { label: 'Invoice Matching', path: '/projects/invoice-matching', hideForExternal: true, requirePage: FINANCE_PAGE },
  // Read-only: issued bills + the to-be-sent queue. Billing (P4) owns creating and editing them.
  { label: 'Billing Status', path: '/projects/billing-status', hideForExternal: true },
  // Scheduling vendors are a manager-only TAB inside Settings (Nick, 2026-10-15), not a menu entry of their own.
  { label: 'Settings', path: '/projects/settings' },
];
